import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {Button, Container} from 'react-bootstrap'

class Start extends Component {


    render(){

        if(document.getElementById('root').offsetWidth > 992)
            this.props.history.push('/start')
        return(
        <Container className='full'>
 <Button onClick={()=>{
            this.props.history.push('/start')

        }} style={{height :'100%', width : '100%'}}>
              <bold>FTP Maintenance</bold>  
            </Button>
      
        </Container>
        )
    }
}

export default withRouter(Start)